import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import { selectGlobalDbnTaxonomyCategoriesListItems, selectGlobalDbnTaxonomyCategoriesQueryItems } from '../../../../redux/global-dbn-taxonomy-categories/selector';

import { globalDbnTaxonomyCategories } from '../../../../redux/global-dbn-taxonomy-categories/action';
import PageLoader from '../../../../components/PageLoader';
import { selectGlobalDbnTaxonomyDomainsListItems } from '../../../../redux/global-dbn-taxonomy-domains/selector';
import { selectCurrent } from '../../../../redux/settings/selectors';
import UploadFiles from '../../../../models/UploadFile';
import { settings } from '../../../../redux/settings/actions';
import { deepCopy } from '../../../../common/services/common.service';
import { selectGlobalDbnTaxonomySubCategoriesListItems } from '../../../../redux/global-dbn-taxonomy-subcategory/selector';
import { routingModels } from '../../../../redux/global-dbn-routing-models/action';
import { selectRoutingModelsListItems, selectRoutingModelsQueryItems } from '../../../../redux/global-dbn-routing-models/selector';
import { selectListItems } from '../../../../redux/library/selector';
import GlobalDbnRoutingModelsComponent from '../../global-dbn-routing-models/components/global-dbn-routing-models-component';
import GlobalDbnBluePrintRegistriesComponent from '../components/global-blue-print-Component';
import { selectGlobalDbnServiceCategoriesListItems } from '../../../../redux/global-dbn-service-category/selector';
import { globalDbnServiceCategories } from '../../../../redux/global-dbn-service-category/action';
type LegTemplate = {
  id: number;
  legType: any;
  movementPattern: any;
  haulClass: any;
  label: any;
  estHoursMin: any;
  estHoursMax: any;
};
let currentChange: any = {}

const GlobalDbnBluePrintRegistry = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const listGlobalDbnRoutingModelsData = useSelector(selectRoutingModelsListItems)
  const listGlobalDbnServiceCategoryData = useSelector(selectGlobalDbnServiceCategoriesListItems)
  const queryGlobalDbnRoutingModelsData = useSelector(selectRoutingModelsQueryItems)
  const listGlobalDbnTaxonomyCategoryData = useSelector(selectGlobalDbnTaxonomyCategoriesListItems)
  const listGlobalDbnTaxonomyDomainData = useSelector(selectGlobalDbnTaxonomyDomainsListItems)
  const listGlobalDbnSubCategoriesData = useSelector(selectGlobalDbnTaxonomySubCategoriesListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [categoryImageIndex, setCategoryImageIndex] = useState<any>([])
  const [mediaFiles, setMediaFiles] = useState<any>([])
  const [openFile, setOpenFile] = useState<any>([]);
  const libraryData = useSelector(selectListItems)

  const [legTemplates, setLegTemplates] = useState<LegTemplate[]>([
    {
      id: 1,
      legType: "",
      movementPattern: "",
      haulClass: "",
      label: "",
      estHoursMin: "",
      estHoursMax: "",
    },
  ]);

  const addLegTemplate = () => {
    setLegTemplates([
      ...legTemplates,
      {
        id: legTemplates.length + 1,
        legType: "",
        movementPattern: "",
        haulClass: "",
        label: "",
        estHoursMin: "",
        estHoursMax: "",
      },
    ]);
  };
  const deleteLegTemplate = (index: number) => {
    const updated = legTemplates.filter((_, i) => i !== index);
    setLegTemplates(updated);
  };
  const [subselectedCategory, setSelectedSubCategory] = useState({
    GlobalDBNCategoryId: 0,
    Name: '',
    Code: '',
  })
  const [selectedGroups, setSelectedGroups] = useState<any[]>([]);
  const [groupValue, setGroupValue] = useState("");


  const handleAddGroup = () => {
    if (!groupValue) return;

    const selected = listGlobalDbnServiceCategoryData?.result?.items.find(
      (item) => item.Id === Number(groupValue)
    );

    if (
      selected &&
      !selectedGroups.some((item) => item.Id === selected.Id)
    ) {
      setSelectedGroups([...selectedGroups, selected]);
      setGroupValue("");
    }
  };

  const handleDeleteGroup = (id: number) => {
    setSelectedGroups(
      selectedGroups.filter((item) => item.Id !== id)
    );
  };
  const [selectedCategory, setSelectedCategory] = useState<any>({
    Id: '',
    Code: '',
    Description: '',
    Name: '',
    LifeCycleStatusId: 0,
    PlannerTypeId: 0,
    GlobalDBNRoutingModelId: 0,
    EffectiveDateToUtc: '',
    EffectiveDateFromUtc: ''
  })
  const [entityAttributes, setEntityAttributes] = useState<any>([]);
  const parentCategory = listGlobalDbnTaxonomyCategoryData?.result?.items.filter(
    (subDomainData: any) => subDomainData.IsSubCategory === false
  )
  useEffect(() => {
    fetchroutingModels()
    fetchGlobalDbnServiceCategories()
    if (parmas?.id > 0) {
      fetchGlobalDbnTaxonomyCategoryById();
    }
  }, []);
  const fetchGlobalDbnTaxonomyCategoryById = async () => {
    await dispatch(routingModels.resetAction({ actionType: 'query' }))
    await dispatch(routingModels.query({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-dbn-cloud/dbn-routing/blue-print-registries/fetch-detail`,
      entity: 'routingModels',
      jsonData:
      {
        "Context": {
        },
        "Records": [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const fetchroutingModels = async () => {
    await dispatch(routingModels.resetAction({ actionType: 'list' }))
    await dispatch(routingModels.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-dbn-cloud/dbn-routing-models/fetch`,
      entity: 'routingModels',
      jsonData:
      {
        "Context": {},
        "Records": [
          {}
        ],
        "Pagination": {
          "PageNumber": 1,
          "PageSize": 100,
          "SortField": "GlobalDBNRoutingModelId",
          "SortOrder": "desc"
        }
      }
    }))
  }
  const handleInnerFormChange = (value: any, field?: string) => {
    if (typeof value === 'object' && !field) {
      setSelectedCategory((prev: any) => ({
        ...prev,
        ...value,
      }));
      return;
    }

    setSelectedCategory((prev: any) => ({
      ...prev,
      [field as string]: value,
    }));
  };

  const handleInnerLegTemplateChange = (
    value: any,
    field: string,
    index: number
  ) => {
    setLegTemplates((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
            ...item,
            [field]: value,
          }
          : item
      )
    );
  };
  const handleSelectedGroups = (selectedItem: any) => {
    if (!selectedItem) return;

    setSelectedGroups((prev: any[]) => {
      const alreadyExists = prev.some(
        (item) =>
          item.GlobalDBNServiceCategoryGroupId ===
          selectedItem.GlobalDBNServiceCategoryGroupId
      );

      if (alreadyExists) {
        return prev;
      }

      return [
        ...prev,
        {
          Id: selectedItem.Id,
          GlobalDBNServiceCategoryGroupId:
            selectedItem.GlobalDBNServiceCategoryGroupId,
          Name: selectedItem.Name,
          Code: selectedItem.Code,
        },
      ];
    });
  };
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }

useEffect(() => {
  if (isQuery) {
    const apiData =
      queryGlobalDbnRoutingModelsData?.result?.items;

    if (!apiData) return;

    setSelectedCategory({
      GlobalBluePrintRegistryId:
        apiData?.GlobalBluePrintRegistryId || 0,
      GlobalDBNRoutingModelId:
        apiData?.GlobalDBNRoutingModelId || 0,
      Description: apiData?.Description || "",
      LifeCycleStatusId:
        apiData?.LifeCycleStatusId || 0,
      Name: apiData?.Name || "",
    });

    setSelectedGroups(
      apiData?.ServiceCategoryGroups?.map((group: any) => ({
        Id: group?.Id || 0,
        GlobalDBNServiceCategoryGroupId:
          group?.Id || 0,
        Name: group?.Name || "",
        Code: group?.Code || "",
      })) || []
    );

    // IMPORTANT FIX → legTemplates must be array
    setLegTemplates(
      apiData?.LegTemplates?.map(
        (leg: any, index: number) => ({
          id: index + 1,
          legType: leg?.LegTypeId || "",
          movementPattern:
            leg?.MovementPatternId || "",
          haulClass: leg?.HaulClassId || "",
          label: leg?.Label || "",
          estHoursMin:
            leg?.EstimatedMinimumHour || "",
          estHoursMax:
            leg?.EstimatedMaximumHour || "",
        })
      ) || [
        {
          id: 1,
          legType: "",
          movementPattern: "",
          haulClass: "",
          label: "",
          estHoursMin: "",
          estHoursMax: "",
        },
      ]
    );

    // media files
    const localSelectedMedia =
      addNewMediaFilesRow({
        selectedMediaFilesArg:
          apiData?.MediaMappings?.MediaFiles ||
          mediaFiles,
      });

    setMediaFiles(localSelectedMedia);
  }
}, [isQuery]);
  const handleDelete = (data: any) => {
    setSelectedSubCategory((prevState: any) =>
      prevState.filter((item: any) => item?.Name !== data?.Name)
    );

  };
  const fetchGlobalDbnServiceCategories = async () => {
    await dispatch(globalDbnServiceCategories.resetAction({ actionType: 'list' }))
    await dispatch(globalDbnServiceCategories.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-service-category-groups/fetch`,
      entity: 'globalDbnServiceCategories',
      jsonData:
      {
        "Context": {},
        "Records": [
          {}
        ],
        "Pagination": {
          "PageNumber": 1,
          "PageSize": 100,
          "SortField": "GlobalDBNServiceCategoryGroupId",
          "SortOrder": "desc"
        }
      }
    }))
  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )


    if (parmas?.id > 0) {

      entityAttributes?.splice(entityAttributes.length - 1, 1);
      const selectedEntityAttributes: any = entityAttributes?.map((item: any) => {
        const attributes: any = {
          Id: item?.Id,
          EntityAttributeName: item?.EntityAttributeName,
          EntityAttributeTypeId: item?.EntityAttributeTypeId,
          EntityAttributeValue: {
            MultiControlType: {
              ValueItem1: {
                Type: item?.ValueItem1Type || 'string',
                Value: item?.ValueItem1Value || 'string',
                IsSelected: item?.ValueItem1IsSelected || false,
              },
              ValueItem2: {
                Type: item?.ValueItem2Type || 'string',
                Value: item?.ValueItem2Value || 'string',
                IsSelected: item?.ValueItem2IsSelected || false,
              },
              ValueItem3: {
                Type: item?.ValueItem3Type || 'string',
                Value: item?.ValueItem2Value || 'string',
                IsSelected: item?.ValueItem3IsSelected || false,
              },
              ValueItem4: {
                Type: item?.ValueItem4Type || 'string',
                Value: item?.ValueItem4Value || 'string',
                IsSelected: item?.ValueItem4IsSelected || false,
              },
              ValueItem5: {
                Type: item?.ValueItem5Type || 'string',
                Value: item?.ValueItem5Value || 'string',
                IsSelected: item?.ValueItem5IsSelected || false,
              },
            },
            SingleControlType: {
              TextValue: item?.TextValue || 'string',
              NumberValue: item?.NumberValue || 0,
              DateValue: item?.DateValue || '2024-05-22T04:52:47.083',
              FileTypeId: item?.FileTypeId || 0,
              FileMappingUrl: item?.FileMappingUrl || 'string',
            },
          },
          OwnerTypeId: item?.OwnerTypeId || 0,
          OwnerId: Number(parmas?.id) || 0,
        };
        return attributes;
      });

      const categoryData = {
        "Id": selectedCategory?.GlobalBluePrintRegistryId,
        "Description": selectedCategory?.Description,
        "LifeCycleStatusId": selectedCategory?.LifeCycleStatusId
      }
      await dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'update' }))
      await dispatch(globalDbnTaxonomyCategories.update({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-dbn-cloud/dbn-routing/blue-print-registries`,
        entity: 'globalDbnTaxonomyCategories',
        jsonData: {
          Context: {},
          Records: [
            categoryData
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      const categoryData = {
        GlobalDBNRoutingModelId: selectedCategory?.GlobalDBNRoutingModelId,
        Description: selectedCategory?.Description,
        LifeCycleStatusId: selectedCategory?.LifeCycleStatusId,

        ServiceCategoryGroups: selectedGroups.map((group) => ({
          Id: group.GlobalDBNServiceCategoryGroupId,
          Name: group.Name,
          Code: group.Code,
        })),

        LegTemplates: legTemplates.map((leg) => ({
          Label: leg.label,
          LegTypeId: leg.legType,
          MovementPatternId: leg.movementPattern,
          HaulClassId: leg.haulClass,
          EstimatedMaximumHour: Number(leg.estHoursMax),
          EstimatedMinimumHour: Number(leg.estHoursMin)
        }))
      };
      await dispatch(routingModels.resetAction({ actionType: 'create' }))
      await dispatch(routingModels.create({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-dbn-cloud/dbn-routing/blue-print-registries`,
        entity: 'routingModels',
        jsonData: {
          Context: {},
          Records: [
            categoryData
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/dbn/global-blue-print-registries')
  }

  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
      OwnerTypeId: 175,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }
    return localSelectedmedia
  }

  const setCombinationInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }

  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setCategoryImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'Category',
      type: fileType
    })
  }


  const handleSubmit = (data: any) => {
    mediaFiles[categoryImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }

  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))
  }

  useEffect(() => {
    if (currentChange.field === 'FileTypeId') {
      setCombinationInfo()
    }
  }, [mediaFiles]
  )

  return (
    <>
      {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
        ownerId={parmas?.id}
      />}
      {listGlobalDbnTaxonomyDomainData?.isLoading ||
        listGlobalDbnTaxonomyCategoryData?.isLoading ||
        queryGlobalDbnRoutingModelsData?.isLoading ? <PageLoader /> :
        <GlobalDbnBluePrintRegistriesComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedCategory={selectedCategory}
          subselectedCategory={subselectedCategory}
          handleDelete={handleDelete}
          addLegTemplate={addLegTemplate}
          legTemplates={legTemplates}
          deleteLegTemplate={deleteLegTemplate}
          handleSelectedGroups={handleSelectedGroups}
          HaulClass={libraryData?.result?.HaulClass}
          RoutingModels={listGlobalDbnRoutingModelsData?.result?.items}
          GlobalDbnServiceCategory={listGlobalDbnServiceCategoryData?.result?.items}
          back={back}
          handleAddGroup={handleAddGroup}
          handleDeleteGroup={handleDeleteGroup}
          handleInnerLegTemplateChange={handleInnerLegTemplateChange}
          handleFormSubmit={handleFormSubmit}
          entityAttributes={entityAttributes}
          setEntityAttributes={setEntityAttributes}
          id={parmas?.id}
          LegType={libraryData?.result?.LegType}
          LifeCycleStatus={libraryData?.result?.LifeCycleStatus}
          MovementPattern={libraryData?.result?.MovementPattern}
          handleFormItemChange={handleFormItemChange}
          mediaFiles={mediaFiles}
          changeImage={changeImage}
          selectedGroups={selectedGroups}

        />
      }
    </>
  )
}

export default GlobalDbnBluePrintRegistry;
